import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import "react-dates/initialize";
import useUniqueId from "../../../../../Hooks/useUniqueId";
import ActivityItemTypeService from "../../../../../../Domain/ActivityItemType/ActivityItemType.service";
import useService from "../../../../../Hooks/useService";
import ActivityService from "../../../../../../Services/Activity.service";
import DeprecatedSelect from "../../../../../UI/DeprecatedSelect/DeprecatedSelect";
export const getItemEventSearchPieceFromTaskFilterState = (state) => {
    if (!state.statuses) {
        return null;
    }
    return {
        activityItemTypeIds: [ActivityItemTypeService.TaskId],
        itemStatusIds: state.statuses && state.statuses.map((status) => status.id),
    };
};
const TaskFilters = (props) => {
    const makeId = useUniqueId()[1];
    const [itemStatuses, loadItemStatuses] = useService(ActivityService.searchItemStatuses);
    React.useEffect(() => {
        loadItemStatuses([ActivityItemTypeService.TaskId]);
    }, [loadItemStatuses]);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("status"), className: "sr-only", children: "Status" }), _jsx(DeprecatedSelect, { id: makeId("status"), "aria-label": "Status", placeholder: "Status", options: itemStatuses.data || [], multi: true, value: props.search.statuses, isLoading: itemStatuses.isLoading, labelKey: "name", valueKey: "id", onChange: (statuses) => props.setSearch((search) => (Object.assign(Object.assign({}, search), { statuses }))) })] }) }));
};
export default TaskFilters;
